(() => {
  function initializeWizard(root) {
    if (root.dataset.initialized === 'true') return;

    const formId = root.dataset.productFormId;
    const form = document.getElementById(formId);
    const variantInput = form?.querySelector('input[name="id"]');
    const addButton = form?.querySelector('[type="submit"]');
    const progress = root.querySelector('[data-wizard-progress]');
    const totalOutput = root.querySelector('[data-wizard-total]');
    const variantError = root.querySelector('[data-variant-error]');
    const errorOutput = root.querySelector('[data-wizard-error]');
    const nextButton = root.querySelector('[data-step-next]');
    const backButton = root.querySelector('[data-step-back]');
    const photoInput = root.querySelector('[data-wizard-photo]');
    const photoName = root.querySelector('[data-photo-name]');
    const basePrice = (() => {
      try {
        const node = root.querySelector('[data-togerano-variants]');
        const list = node ? JSON.parse(node.textContent) : [];
        const lowest = list.reduce((min, item) => Math.min(min, item.price), Infinity);
        return Number.isFinite(lowest) ? lowest : Number(root.dataset.basePrice || 0);
      } catch (error) {
        return Number(root.dataset.basePrice || 0);
      }
    })();
    const moneyFormat = root.dataset.moneyFormat || window.money_format;
    const productView = root.closest('.productView');
    const extrasPropertyInput = root.querySelector('[data-wizard-extras-property]');

    if (!form || !variantInput || !addButton || !progress || !nextButton || !backButton) return;
    root.dataset.initialized = 'true';

    // Fill frame price badges from real variant price differences
    setTimeout(() => {
      root.querySelectorAll('[data-frame-price]').forEach((el) => {
        const label = el.getAttribute('data-frame-price') || '';
        const delta = label && label !== 'No Frame' ? frameSurcharge(label) : 0;
        if (delta > 0) {
          el.textContent = '+' + formatMoney(delta);
          el.hidden = false;
        } else {
          el.remove();
        }
      });
    }, 0);

    let productOptions = [];
    let variants = [];
    try {
      productOptions = JSON.parse(root.querySelector('[data-togerano-options]')?.textContent || '[]');
      variants = JSON.parse(root.querySelector('[data-togerano-variants]')?.textContent || '[]');
    } catch (error) {
      console.error('Togerano product wizard could not read product variants.', error);
    }

    form.dataset.togeranoNativeUpload = 'true';
    form.method = 'post';
    form.enctype = 'multipart/form-data';
    if (productView) productView.classList.add('togerano-wizard-active');

    const sizeSurcharges = {
      'Digital Download': 0,
      '8" x 10"': 2900,
      '12" x 16"': 4300,
      '18" x 24"': 5700,
    };
    const extraSurcharges = {
      None: 0,
      'Preview Your Artwork Sooner': 2200,
      'Certificate of Authenticity': 800,
      'Both Add-ons': 3000,
    };

    const panelMap = new Map(
      [...root.querySelectorAll('[data-wizard-panel]')].map((panel) => [panel.dataset.wizardPanel, panel]),
    );
    const hasBackground = Boolean(panelMap.get('background'));
    let currentStep = 'size';
    let activeSteps = [];
    let matchedVariant = null;

    const optionIndexOf = (keywords) => {
      if (!Array.isArray(productOptions)) return -1;
      return productOptions.findIndex((name) => {
        const normalized = String(name || '').trim().toLowerCase();
        return keywords.some((keyword) => normalized.includes(keyword));
      });
    };

    const sizeOptionIndex = optionIndexOf(['size', '尺寸', '大小', '规格']);
    const frameOptionIndex = optionIndexOf(['fram', '框']);
    const extrasOptionIndex = optionIndexOf(['extra', 'add-on', 'addon', 'add on', '附加', '增值', '加购']);

    const normalizeOption = (value) => String(value || '')
      .trim()
      .replace(/[\u2018\u2019\u02BC\u2032]/g, "'")
      .replace(/[\u201C\u201D\u02BA\u2033]/g, '"')
      .replace(/[\u00D7\u2715]/g, 'x')
      .replace(/\s+/g, ' ')
      .toLowerCase();

    const optionValueAt = (variant, index) => {
      if (!variant || index < 0) return null;
      return normalizeOption(variant[`option${index + 1}`]);
    };

    const distinctValues = (index) => {
      if (index < 0 || !Array.isArray(variants)) return [];
      const seen = new Set();
      const out = [];
      variants.forEach((variant) => {
        const value = String(variant[`option${index + 1}`] || '').trim();
        if (value && !seen.has(value)) {
          seen.add(value);
          out.push(value);
        }
      });
      return out;
    };

    if (sizeOptionIndex < 0) {
      console.warn('Togerano wizard: no product option containing "size" was found. Options are:', productOptions);
    }
    if (Array.isArray(productOptions) && Array.isArray(variants)) {
      console.info('Togerano wizard options:', productOptions, 'variants:', variants);
    }

    function selected(key) {
      return root.querySelector(`[data-wizard-choice="${key}"]:checked`)?.value || '';
    }

    function extrasValue() {
      const preview = Boolean(root.querySelector('[data-wizard-extra="preview"]')?.checked);
      const certificate = Boolean(root.querySelector('[data-wizard-extra="certificate"]')?.checked);
      if (preview && certificate) return 'Both Add-ons';
      if (preview) return 'Preview Your Artwork Sooner';
      if (certificate) return 'Certificate of Authenticity';
      return 'None';
    }

    function sizeSurcharge(sizeValue) {
      if (!Array.isArray(variants) || variants.length === 0 || sizeOptionIndex < 0) {
        return sizeSurcharges[sizeValue] || 0;
      }
      const wanted = normalizeOption(sizeValue);
      let sizeMin = Infinity;
      let globalMin = Infinity;
      variants.forEach((variant) => {
        if (variant.price < globalMin) globalMin = variant.price;
        if (optionValueAt(variant, sizeOptionIndex) === wanted && variant.price < sizeMin) {
          sizeMin = variant.price;
        }
      });
      if (!Number.isFinite(sizeMin) || !Number.isFinite(globalMin)) {
        return sizeSurcharges[sizeValue] || 0;
      }
      return Math.max(0, sizeMin - globalMin);
    }

    // MEDIAN-FIX: use per-size deltas so one mispriced size cannot zero out the badge
    function frameSurcharge(frameValue) {
      if (!Array.isArray(variants) || variants.length === 0 || frameOptionIndex < 0) return 5700;
      const wanted = normalizeOption(frameValue);
      const deltas = [];
      variants.forEach((variant) => {
        const sizeValue = optionValueAt(variant, sizeOptionIndex);
        if (sizeValue === 'digital download') return;
        if (optionValueAt(variant, frameOptionIndex) !== wanted) return;
        if (extrasOptionIndex >= 0 && optionValueAt(variant, extrasOptionIndex) !== 'none') return;
        const base = variants.find((candidate) => optionValueAt(candidate, sizeOptionIndex) === sizeValue
          && optionValueAt(candidate, frameOptionIndex) === 'no frame'
          && (extrasOptionIndex < 0 || optionValueAt(candidate, extrasOptionIndex) === 'none'));
        if (base) deltas.push(variant.price - base.price);
      });
      const usable = deltas.filter((value) => Number.isFinite(value) && value >= 0);
      if (!usable.length) return 5700;
      usable.sort((a, b) => a - b);
      const middle = Math.floor(usable.length / 2);
      const median = usable.length % 2 === 1 ? usable[middle] : Math.round((usable[middle - 1] + usable[middle]) / 2);
      return Math.max(0, median);
    }

    function estimatePrice() {
      const size = selected('size');
      const frame = selected('framing');
      const extras = extrasValue();
      const frameCharge = frame && frame !== 'No Frame' ? frameSurcharge(frame) : 0;
      return basePrice + sizeSurcharge(size) + frameCharge + (extraSurcharges[extras] || 0);
    }

    function findVariant() {
      if (!Array.isArray(variants) || variants.length === 0 || sizeOptionIndex < 0) return null;

      const rawSize = selected('size');
      if (!rawSize) return null;

      const isDigital = rawSize === 'Digital Download';
      const rawFrame = isDigital ? 'No Frame' : selected('framing');
      if (!isDigital && !rawFrame) return null;

      const chosenSize = normalizeOption(rawSize);
      const chosenFrame = normalizeOption(rawFrame);

      const matchesCore = (variant) =>
        optionValueAt(variant, sizeOptionIndex) === chosenSize &&
        (frameOptionIndex < 0 || optionValueAt(variant, frameOptionIndex) === chosenFrame);

      const coreVariant = variants.find(matchesCore) || null;

      // Extras are optional. If the product has an "extras" option with matching
      // values, prefer a variant that also matches it (so its price is applied);
      // otherwise fall back to the size + frame variant so the customer can still
      // add to cart without extras.
      if (extrasOptionIndex >= 0) {
        const chosenExtras = normalizeOption(extrasValue());
        const withExtras = variants.find(
          (variant) => matchesCore(variant) && optionValueAt(variant, extrasOptionIndex) === chosenExtras,
        ) || null;
        if (withExtras) return withExtras;
      }

      return coreVariant;
    }

    function formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.shop_currency || 'USD',
      }).format(cents / 100);
    }

    function stepsForCurrentSelection() {
      const steps = ['size'];
      if (selected('size') !== 'Digital Download') steps.push('framing');
      if (hasBackground) steps.push('background');
      steps.push('upload', 'extras');
      return steps;
    }

    function stepLabel(key) {
      return {
        size: 'Size',
        framing: 'Framing',
        background: 'Background',
        upload: 'Upload',
        extras: 'Extras',
      }[key] || key;
    }

    function currentIndex() {
      const index = activeSteps.indexOf(currentStep);
      return index < 0 ? 0 : index;
    }

    function showError(message) {
      if (!errorOutput) return;
      errorOutput.textContent = message;
      errorOutput.hidden = !message;
    }

    function renderProgress() {
      activeSteps = stepsForCurrentSelection();
      if (!activeSteps.includes(currentStep)) currentStep = activeSteps[Math.min(currentIndex(), activeSteps.length - 1)] || 'size';

      progress.style.setProperty('--wizard-step-count', String(activeSteps.length));
      progress.replaceChildren();
      activeSteps.forEach((key, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'togerano-wizard__step';
        button.dataset.stepTarget = key;
        button.setAttribute('aria-current', key === currentStep ? 'step' : 'false');
        button.disabled = index > currentIndex();
        if (key === currentStep) button.classList.add('is-current');
        if (index < currentIndex()) button.classList.add('is-complete');

        const number = document.createElement('span');
        number.className = 'togerano-wizard__step-number';
        number.textContent = String(index + 1);
        const label = document.createElement('span');
        label.className = 'togerano-wizard__step-label';
        label.textContent = stepLabel(key);
        button.append(number, label);
        progress.append(button);
      });

      activeSteps.forEach((key, index) => {
        const panel = panelMap.get(key);
        if (!panel) return;
        panel.hidden = key !== currentStep;
        const title = panel.querySelector('.togerano-wizard__title');
        if (title) {
          const titles = {
            size: 'Choose your size',
            framing: 'Choose your frame',
            background: 'Choose a background',
            upload: 'Upload your pet photo',
            extras: 'Add any extras',
          };
          title.textContent = `${index + 1}. ${titles[key]}`;
        }
      });

      const finalStep = currentStep === 'extras';
      nextButton.hidden = finalStep;
      backButton.hidden = currentIndex() === 0;
      if (productView) productView.classList.toggle('togerano-wizard-final', finalStep);
      if (addButton) addButton.setAttribute('aria-label', finalStep ? 'Add configured portrait to cart' : 'Complete product options first');
      updateVariant();
    }

    function updateVariant() {
      matchedVariant = findVariant();
      const estimated = estimatePrice();
      const displayedPrice = matchedVariant ? Number(matchedVariant.price) : estimated;
      if (totalOutput) totalOutput.innerHTML = formatMoney(displayedPrice);

      const chosenSize = selected('size');
      const complete = Boolean(chosenSize) && (chosenSize === 'Digital Download' || Boolean(selected('framing')));
      const allSelectionsPresent = complete && (!hasBackground || Boolean(selected('background')));
      const isConfigured = Boolean(matchedVariant && matchedVariant.available !== false);

      if (variantError) {
        variantError.hidden = isConfigured || !allSelectionsPresent;
        if (!isConfigured && allSelectionsPresent) {
          const chosenFrame = chosenSize === 'Digital Download' ? 'No Frame' : selected('framing');
          const optionNames = Array.isArray(productOptions) && productOptions.length ? productOptions.join(' | ') : 'none';
          const variantCount = Array.isArray(variants) ? variants.length : 0;
          const sizeValues = distinctValues(sizeOptionIndex).join(' | ');
          const frameValues = distinctValues(frameOptionIndex).join(' | ');
          const extrasValues = distinctValues(extrasOptionIndex).join(' | ');
          variantError.textContent =
            'No matching variant for Size="' + chosenSize + '", Frame="' + chosenFrame + '", Extras="' + extrasValue() + '". ' +
            'Product option names: [' + optionNames + '], ' + variantCount + ' variant(s). ' +
            'Size values: [' + (sizeValues || 'none') + '] | Frame values: [' + (frameValues || 'none') + ']' +
            (extrasOptionIndex >= 0 ? ' | Extras values: [' + (extrasValues || 'none') + ']' : '') + '.';
        }
      }
      if (extrasPropertyInput) extrasPropertyInput.value = extrasValue();

      if (variantInput && matchedVariant) {
        variantInput.value = matchedVariant.id;
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (addButton) addButton.disabled = !isConfigured;
      if (nextButton) nextButton.disabled = !allSelectionsPresent && currentStep === 'framing' && selected('size') === 'Digital Download';
    }

    function validateStep(key) {
      if (key === 'size' && !selected('size')) return 'Please choose a size to continue.';
      if (key === 'framing' && selected('size') !== 'Digital Download' && !selected('framing')) return 'Please choose a frame to continue.';
      if (key === 'background' && !selected('background')) return 'Please choose a background to continue.';
      if (key === 'upload' && (!photoInput || !photoInput.files || photoInput.files.length === 0)) return 'Please upload your pet photo to continue.';
      return '';
    }

    function goToStep(key) {
      if (!activeSteps.includes(key)) return;
      currentStep = key;
      showError('');
      renderProgress();
      root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    nextButton.addEventListener('click', () => {
      const message = validateStep(currentStep);
      if (message) {
        showError(message);
        return;
      }
      const index = currentIndex();
      goToStep(activeSteps[index + 1] || 'extras');
    });

    backButton.addEventListener('click', () => {
      const index = currentIndex();
      goToStep(activeSteps[Math.max(0, index - 1)] || 'size');
    });

    progress.addEventListener('click', (event) => {
      const targetButton = event.target.closest('[data-step-target]');
      if (!targetButton || targetButton.disabled) return;
      goToStep(targetButton.dataset.stepTarget);
    });

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-wizard-choice="size"]')) {
        if (event.target.value === 'Digital Download') {
          const noFrame = root.querySelector('[data-wizard-choice="framing"][value="No Frame"]');
          if (noFrame) noFrame.checked = true;
          const note = root.querySelector('[data-digital-frame-note]');
          if (note) note.hidden = false;
        } else {
          const note = root.querySelector('[data-digital-frame-note]');
          if (note) note.hidden = true;
        }
        if (currentStep !== 'size') currentStep = 'size';
      }
      if (event.target.matches('[data-wizard-photo]') && photoName) {
        photoName.textContent = event.target.files?.[0]?.name || 'No photo selected';
      }
      showError('');
      renderProgress();
    });

    form.addEventListener('submit', (event) => {
      if (currentStep !== 'extras') {
        event.preventDefault();
        showError('Please complete each step before adding your portrait to the cart.');
        return;
      }
      const missingStep = activeSteps.find((key) => validateStep(key));
      const message = missingStep ? validateStep(missingStep) : '';
      if (message) {
        event.preventDefault();
        goToStep(missingStep);
        showError(message);
        return;
      }
      if (!matchedVariant || matchedVariant.available === false) {
        event.preventDefault();
        showError('This option combination is not available yet. Please contact the store.');
        return;
      }
      variantInput.value = matchedVariant.id;
    }, true);

    renderProgress();
  }

  function initializeWizardsWithin(container) {
    if (!container) return;
    if (container.matches && container.matches('[data-togerano-product-wizard]')) {
      initializeWizard(container);
    }
    if (container.querySelectorAll) {
      container.querySelectorAll('[data-togerano-product-wizard]').forEach(initializeWizard);
    }
  }

  initializeWizardsWithin(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeWizardsWithin(event.target);
  });
})();
  